import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Unlock icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Unlock } from '@sravni/design-system-icons'
 *
 * <Unlock />
 * ```
 */
var Unlock = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Unlock", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.167 17.5H5.833c-.92 0-1.666-.746-1.666-1.667V10c0-.92.746-1.667 1.666-1.667h8.334c.92 0 1.666.746 1.666 1.667v5.833c0 .921-.745 1.667-1.666 1.667ZM13.333 5.833a3.327 3.327 0 0 0-6.555-.814M13.333 8.333v-2.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Unlock };
//# sourceMappingURL=Unlock.js.map
